module.exports = __webpack_public_path__ + "static/MoreBenefits-32ea8253dcc25a863b3a73292a9a0cee.svg";